var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"layout",staticClass:"layout--services"},[_c('header-block',{ref:"header"}),_c('main',{ref:"main",staticClass:"page"},[_c('div',{staticClass:"page__container"},[_vm._t("default")],2)]),_c('footer-block',{ref:"footer"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }